(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const COMPONENT_NAME = 'animated-search-text';

    if (customElements.get(COMPONENT_NAME)) return;

    class AnimatedSearchText extends HTMLElement {
      #overlay = null;
      #typewriterElement = null;
      #input = null;
      #field = null;
      #desktopForm = null;
      #phrases = [];
      #fallbackPlaceholder = '';
      #phraseIndex = 0;
      #charIndex = 0;
      #isDeleting = false;
      #timeoutId = null;
      #isRunning = false;
      #layoutObserver = null;
      #intersectionObserver = null;

      static TYPE_SPEED_MS = 80;
      static DELETE_SPEED_MS = 50;
      static PAUSE_MS = 1200;

      connectedCallback() {
        this.#overlay = this.querySelector(
          '[data-animated-search-text-overlay]',
        );
        this.#typewriterElement = this.querySelector(
          '[data-animated-search-text-typewriter]',
        );
        this.#phrases = this.#parsePhrases();
        this.#fallbackPlaceholder = this.dataset.fallbackPlaceholder || '';
        // The field hosts the phrase-width probe and receives
        // --header-search-field-min-width; without it the probe measures on
        // document.body and long phrases clip inside the pill.
        this.#field = this.parentElement;
        this.#input = this.#field?.querySelector(
          '[data-animated-search-text-input]',
        );
        this.#desktopForm = this.closest('.header__search--desktop');

        // Bailing out here leaves the markup as rendered: overlay hidden, real
        // placeholder on the input.
        if (
          !this.#overlay ||
          !this.#typewriterElement ||
          this.#phrases.length === 0
        )
          return;

        // Reduced motion gets the non-animated placeholder — the merchant's
        // fallback, or the theme default — and never the overlay.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          if (this.#input && this.#fallbackPlaceholder) {
            this.#input.placeholder = this.#fallbackPlaceholder;
          }
          return;
        }

        if (this.#input) {
          // The overlay takes over from here, so the input must not paint its
          // own placeholder underneath it.
          this.#input.placeholder = '';
          this.#input.addEventListener('focus', this.#syncVisibility);
          this.#input.addEventListener('blur', this.#syncVisibility);
          this.#input.addEventListener('input', this.#syncVisibility);
        }

        this.#observeLayoutVisibility();
        this.#syncMinWidth();

        // The connect-time measurement reads whatever font is painted at that
        // moment; a webfont that lands afterwards renders the phrases wider
        // than the reserved width and clips the typewriter. Re-measure when
        // the fonts settle and when the viewport changes — the matching
        // removeEventListener is already in disconnectedCallback.
        if (document.fonts?.ready) {
          document.fonts.ready.then(() => this.#syncMinWidth());
        }

        window.addEventListener('resize', this.#syncMinWidth);

        this.#syncVisibility();
        this.#start();
      }

      disconnectedCallback() {
        this.#stop();
        this.#layoutObserver?.disconnect();
        this.#layoutObserver = null;
        this.#intersectionObserver?.disconnect();
        this.#intersectionObserver = null;
        window.removeEventListener('resize', this.#syncMinWidth);
        this.#input?.removeEventListener('focus', this.#syncVisibility);
        this.#input?.removeEventListener('blur', this.#syncVisibility);
        this.#input?.removeEventListener('input', this.#syncVisibility);
        this.#clearMinWidth();
      }

      #parsePhrases() {
        const rawValue = this.dataset.phrases;
        if (!rawValue) return [];

        try {
          const parsed = JSON.parse(rawValue);
          if (!Array.isArray(parsed)) return [];

          return parsed
            .flatMap((phrase) => String(phrase).split(/\r?\n/))
            .map((phrase) => phrase.trim())
            .filter(Boolean)
            .slice(0, 3);
        } catch {
          return [];
        }
      }

      #start() {
        if (this.#isRunning || this.#overlay?.hasAttribute('hidden')) return;

        this.#isRunning = true;
        this.#tick();
      }

      #stop() {
        this.#isRunning = false;

        if (this.#timeoutId) {
          window.clearTimeout(this.#timeoutId);
          this.#timeoutId = null;
        }
      }

      #tick = () => {
        if (!this.#isRunning || this.#overlay?.hasAttribute('hidden')) {
          this.#stop();
          return;
        }

        const phrase = this.#phrases[this.#phraseIndex];

        if (!this.#isDeleting) {
          this.#charIndex += 1;
          this.#typewriterElement.textContent = phrase.slice(
            0,
            this.#charIndex,
          );

          if (this.#charIndex >= phrase.length) {
            this.#timeoutId = window.setTimeout(() => {
              this.#isDeleting = true;
              this.#tick();
            }, AnimatedSearchText.PAUSE_MS);
            return;
          }

          this.#timeoutId = window.setTimeout(
            this.#tick,
            AnimatedSearchText.TYPE_SPEED_MS,
          );
          return;
        }

        this.#charIndex -= 1;
        this.#typewriterElement.textContent = phrase.slice(0, this.#charIndex);

        if (this.#charIndex <= 0) {
          this.#isDeleting = false;
          this.#phraseIndex = (this.#phraseIndex + 1) % this.#phrases.length;
        }

        this.#timeoutId = window.setTimeout(
          this.#tick,
          AnimatedSearchText.DELETE_SPEED_MS,
        );
      };

      #syncVisibility = () => {
        const shouldHide = this.#shouldHide();
        this.#overlay?.toggleAttribute('hidden', shouldHide);
        this.#overlay?.setAttribute('aria-hidden', String(shouldHide));

        if (shouldHide) {
          this.#stop();
          return;
        }

        if (
          !this.#isRunning &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          this.#start();
        }
      };

      #shouldHide() {
        if (!this.#isLayoutVisible()) return true;

        return Boolean(
          this.#input &&
          (document.activeElement === this.#input || this.#input.value !== ''),
        );
      }

      #isLayoutVisible() {
        const form = this.closest('form');
        const probe = this.#input || form || this.#overlay;

        if (!probe) return false;

        if (probe.closest('[hidden]')) return false;

        if (typeof probe.checkVisibility === 'function') {
          return probe.checkVisibility();
        }

        const style = window.getComputedStyle(probe);

        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      #observeLayoutVisibility() {
        const form = this.closest('form');
        const header = this.closest('[data-header]');
        const stacked = this.closest('[data-header-stacked-search]');
        const targets = [form, stacked, header].filter(Boolean);

        if (targets.length > 0) {
          this.#layoutObserver = new MutationObserver(() => {
            this.#syncVisibility();
            this.#syncMinWidth();
          });

          for (const target of targets) {
            this.#layoutObserver.observe(target, {
              attributes: true,
              attributeFilter: ['hidden', 'class'],
            });
          }
        }

        // Catches CSS-only hide/show (e.g. display:none from layout classes).
        if (typeof IntersectionObserver === 'function' && form) {
          this.#intersectionObserver = new IntersectionObserver(() => {
            this.#syncVisibility();
            this.#syncMinWidth();
          });
          this.#intersectionObserver.observe(form);
        }
      }

      #syncMinWidth = () => {
        if (!this.#desktopForm || !this.#overlay || !this.#typewriterElement) {
          return;
        }

        if (this.#phrases.length === 0) return;

        const textWidth = this.#measureLongestOverlayWidth();

        if (textWidth <= 0) return;

        this.#field?.style.setProperty(
          '--header-search-field-min-width',
          `${textWidth}px`,
        );

        const formStyles = window.getComputedStyle(this.#desktopForm);
        const paddingInline =
          (Number.parseFloat(formStyles.paddingInlineStart) || 0) +
          (Number.parseFloat(formStyles.paddingInlineEnd) || 0);
        const gap =
          Number.parseFloat(formStyles.columnGap || formStyles.gap) || 0;
        const iconWidth = this.#getSearchIconWidth();

        this.#desktopForm.style.setProperty(
          '--header-search-min-width',
          `${Math.ceil(paddingInline + iconWidth + gap + textWidth)}px`,
        );
      };

      #getSearchIconWidth() {
        const icon = this.#desktopForm?.querySelector('.header__search-icon');

        if (!icon) return 20;

        const measuredWidth = icon.getBoundingClientRect().width;

        if (measuredWidth > 0) return measuredWidth;

        const iconStyles = window.getComputedStyle(icon);

        return (
          Number.parseFloat(iconStyles.getPropertyValue('--icon-size')) ||
          Number.parseFloat(iconStyles.width) ||
          20
        );
      }

      #measureLongestOverlayWidth() {
        const probe = this.#overlay.cloneNode(true);

        if (!(probe instanceof HTMLElement)) return 0;

        const overlayStyles = window.getComputedStyle(this.#overlay);

        probe.removeAttribute('hidden');
        probe.setAttribute('aria-hidden', 'true');
        probe.style.inset = 'auto';
        probe.style.left = '0';
        probe.style.maxWidth = 'none';
        probe.style.pointerEvents = 'none';
        probe.style.position = 'absolute';
        probe.style.top = '0';
        probe.style.visibility = 'hidden';
        probe.style.width = 'max-content';
        probe.style.fontFamily = overlayStyles.fontFamily;
        probe.style.fontSize = overlayStyles.fontSize;
        probe.style.fontWeight = overlayStyles.fontWeight;
        probe.style.letterSpacing = overlayStyles.letterSpacing;
        probe.style.gap = overlayStyles.gap;

        const typewriter = probe.querySelector(
          '[data-animated-search-text-typewriter]',
        );

        if (!(typewriter instanceof HTMLElement)) return 0;

        // Undo live ellipsis/shrink so the probe reports full phrase width.
        typewriter.style.flex = '0 0 auto';
        typewriter.style.minWidth = 'max-content';
        typewriter.style.overflow = 'visible';
        typewriter.style.textOverflow = 'clip';

        // Prefer the field when laid out; otherwise measure on body so hidden
        // stacked/compact/mobile search still publishes --header-search-min-width.
        const host = this.#canMeasureInField() ? this.#field : document.body;

        host?.appendChild(probe);

        let textWidth = 0;

        for (const phrase of this.#phrases) {
          typewriter.textContent = phrase;
          textWidth = Math.max(textWidth, Math.ceil(probe.scrollWidth));
        }

        probe.remove();

        return textWidth;
      }

      #canMeasureInField() {
        if (!this.#field || !this.#desktopForm) return false;
        if (this.#field.closest('[hidden]')) return false;

        const style = window.getComputedStyle(this.#desktopForm);

        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      #clearMinWidth() {
        this.#field?.style.removeProperty('--header-search-field-min-width');
        this.#desktopForm?.style.removeProperty('--header-search-min-width');
      }
    }

    customElements.define(COMPONENT_NAME, AnimatedSearchText);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    const NAME = 'product-dynamic-badges';

    class ProductDynamicBadges extends HTMLElement {
      #boundVariantChange = null;
      #variants = [];
      #lowStockThreshold = 5;
      #productAvailable = true;

      connectedCallback() {
        this.#lowStockThreshold = Number(this.dataset.lowStockThreshold || 5);
        this.#productAvailable = this.dataset.productAvailable !== 'false';

        try {
          this.#variants = JSON.parse(this.dataset.variants || '[]');
        } catch (error) {
          this.#variants = [];
        }

        this.#boundVariantChange = (event) => this.#onVariantChange(event);
        document.addEventListener('variant:change', this.#boundVariantChange);
        this.#syncFromSelectedVariant();
      }

      disconnectedCallback() {
        document.removeEventListener(
          'variant:change',
          this.#boundVariantChange,
        );
      }

      #staticBadges() {
        return [...this.children].filter(
          (child) =>
            !child.matches('[data-badge-sale], [data-badge-low-stock]'),
        );
      }

      #selectedVariant() {
        // Prefer product-form / product-card — do not use [data-product-id]
        // because that matches this host and misses the sibling form input.
        const scope =
          this.closest('product-form') ||
          this.closest('.product-card') ||
          this.closest('form');
        const variantInput = scope?.querySelector('[data-variant-input]');
        const selectedId = variantInput ? Number(variantInput.value) : null;

        if (selectedId) {
          const match = this.#variants.find(
            (item) => Number(item.id) === selectedId,
          );
          if (match) return match;
        }

        return this.#variants[0] || null;
      }

      #syncFromSelectedVariant() {
        const full = this.#selectedVariant();

        if (!full) return;

        const onSale =
          this.#productAvailable &&
          Number(full.compare_at_price) > Number(full.price);

        const inventoryQty = Number(full.inventory_quantity ?? 0);
        const lowStock =
          Boolean(full.available) &&
          Boolean(full.inventory_management) &&
          inventoryQty > 0 &&
          inventoryQty <= this.#lowStockThreshold;

        this.#applyBadgeVisibility(onSale, lowStock);
      }

      #applyBadgeVisibility(onSale, lowStock) {
        const limit = Number(this.dataset.badgeLimit || 2);
        const staticBadges = this.#staticBadges();

        for (const badge of staticBadges) {
          badge.hidden = false;
        }

        let used = staticBadges.filter((badge) => !badge.hidden).length;

        const saleNode = this.querySelector('[data-badge-sale]');
        const lowStockNode = this.querySelector('[data-badge-low-stock]');

        if (saleNode) {
          if (onSale) {
            if (used >= limit && staticBadges.length > 0) {
              staticBadges[staticBadges.length - 1].hidden = true;
              used -= 1;
            }

            saleNode.hidden = used >= limit;
            if (!saleNode.hidden) used += 1;
          } else {
            saleNode.hidden = true;
          }
        }

        if (lowStockNode) {
          if (lowStock) {
            if (used >= limit && staticBadges.length > 0) {
              const lastVisible = [...staticBadges]
                .reverse()
                .find((badge) => !badge.hidden);

              if (lastVisible) {
                lastVisible.hidden = true;
                used -= 1;
              }
            }

            lowStockNode.hidden = used >= limit;
          } else {
            lowStockNode.hidden = true;
          }
        }
      }

      #onVariantChange(event) {
        const variant = event.detail?.variant;
        const eventProductId = event.detail?.product?.id;

        if (!variant?.id) return;

        // Ignore variant changes from other products (carousel cards, etc.)
        if (
          this.dataset.productId &&
          eventProductId != null &&
          Number(eventProductId) !== Number(this.dataset.productId)
        ) {
          return;
        }

        const full = this.#variants.find(
          (item) => Number(item.id) === Number(variant.id),
        );

        // Do not fall back to a foreign variant payload
        if (!full) return;

        const onSale =
          this.#productAvailable &&
          Number(full.compare_at_price) > Number(full.price);

        const inventoryQty = Number(full.inventory_quantity ?? 0);
        const lowStock =
          Boolean(full.available) &&
          Boolean(full.inventory_management) &&
          inventoryQty > 0 &&
          inventoryQty <= this.#lowStockThreshold;

        this.#applyBadgeVisibility(onSale, lowStock);
      }
    }

    if (!customElements.get(NAME)) {
      customElements.define(NAME, ProductDynamicBadges);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    /* Klaviyo owns the modal, the list and the validation — the theme only opens
     the merchant's chosen form and tells Klaviyo which variant it is for. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-notify-trigger]');

    if (!trigger) return;

    const formId = trigger.dataset.klaviyoFormId;

    if (!formId) return;

    event.preventDefault();

    window.__rokaNotifyContext = {
      variantId: trigger.dataset.variantId || null,
    };

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const COMPONENT_NAME = 'product-card';
    const INIT_ROOT_MARGIN = '200px';
    const SWIPER_RETRY_LIMIT = 40;
    const SWIPER_RETRY_DELAY = 50;
    const NUDGE_DELAY = 600;
    const NUDGE_PEEK_RATIO = 0.3;
    const NUDGE_SPEED = 400;
    const NUDGE_HOLD = 500;
    const NUDGE_SESSION_KEY = 'roka:product-card-nudge';
    const NUDGE_VISIBLE_RATIO = 0.5;
    const VIDEO_SELECTOR = '.product-card__slide video';
    const RATING_ATTR = 'data-ls-product-rating';
    const VOTES_ATTR = 'data-ls-product-votes';
    /* Lipscore scores are 0-10; the design shows them out of 5. */
    const RATING_SCALE = 2;

    if (customElements.get(COMPONENT_NAME)) return;

    class ProductCard extends HTMLElement {
      #media = null;
      #swiperElement = null;
      #swiper = null;
      #slideCount = 0;
      #hasVideo = false;
      #observer = null;
      #timers = [];
      #reviews = null;
      #reviewText = null;
      #reviewCount = null;
      #reviewSource = null;
      #reviewObserver = null;
      #nudgeObserver = null;
      #nudgeVisible = false;

      connectedCallback() {
        this.#initReviews();

        this.#media = this.querySelector('[data-product-card-media]');
        this.#swiperElement = this.querySelector('[data-product-card-swiper]');
        this.#slideCount = this.querySelectorAll(
          '[data-product-card-slide]',
        ).length;
        this.#hasVideo = this.querySelector(VIDEO_SELECTOR) !== null;

        if (!this.#media || !this.#swiperElement) return;
        if (this.#slideCount < 2) return;

        this.#observeForInit();
      }

      /* Paint our own rating pill from whatever Lipscore's widget resolves.
         Their script writes the score back onto the mounted span as data
         attributes once it has hydrated, so watch for those rather than
         restyling their markup. Silent no-op if the app embed is disabled. */
      #initReviews() {
        this.#reviews = this.querySelector('[data-product-card-reviews]');
        this.#reviewText = this.querySelector(
          '[data-product-card-review-text]',
        );
        this.#reviewCount = this.querySelector(
          '[data-product-card-review-count]',
        );
        this.#reviewSource = this.querySelector('.lipscore-rating-small');

        if (!this.#reviews || !this.#reviewText) return;
        if (!this.#reviewSource) return;
        if (this.#syncReviews()) return;

        this.#reviewObserver = new MutationObserver(() => this.#syncReviews());
        this.#reviewObserver.observe(this.#reviewSource, {
          attributes: true,
          attributeFilter: [RATING_ATTR, VOTES_ATTR],
        });
      }

      #syncReviews() {
        const rating = Number(this.#reviewSource.getAttribute(RATING_ATTR));
        const votes = Number(this.#reviewSource.getAttribute(VOTES_ATTR));

        if (!Number.isFinite(rating) || rating <= 0) return false;
        if (!Number.isFinite(votes) || votes <= 0) return false;

        this.#reviewText.textContent = (rating / RATING_SCALE).toFixed(1);

        if (this.#reviewCount) {
          const countTemplate =
            this.#reviews.dataset.reviewCountTemplate?.trim() || '(%count%)';

          this.#reviewCount.textContent = countTemplate.replace(
            '%count%',
            String(votes),
          );
        }
        this.#reviews.hidden = false;

        this.#reviewObserver?.disconnect();
        this.#reviewObserver = null;

        return true;
      }

      disconnectedCallback() {
        this.#reviewObserver?.disconnect();
        this.#reviewObserver = null;
        this.#observer?.disconnect();
        this.#observer = null;
        this.#nudgeObserver?.disconnect();
        this.#nudgeObserver = null;

        for (const timer of this.#timers) {
          window.clearTimeout(timer);
        }

        this.#timers = [];

        this.#pauseVideos();
        this.#swiper?.destroy(true, true);
        this.#swiper = null;
      }

      /* Only pay for a Swiper instance once the card is near the viewport.
         Cards with video keep the observer after init: a muted loop goes on
         decoding off-screen, so scrolling past one has to stop it. */
      #observeForInit() {
        if (!('IntersectionObserver' in window)) {
          this.#initSwiper();
          return;
        }

        this.#observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) {
              this.#pauseVideos();
              return;
            }

            if (!this.#hasVideo) {
              this.#observer.disconnect();
              this.#observer = null;
            }

            this.#initSwiper();
          },
          { rootMargin: INIT_ROOT_MARGIN },
        );

        this.#observer.observe(this);
      }

      #pauseVideos(except = null) {
        for (const video of this.querySelectorAll(VIDEO_SELECTOR)) {
          if (video === except) continue;

          video.pause();
        }
      }

      /* Play the video the shopper landed on, and only that one. Nothing plays
         on init, so a card that is merely scrolled past never spends the
         bytes — with preload="none" the play() call is what starts the
         download. play() rejects when the browser blocks it; swallow it. */
      #playActiveVideo() {
        if (!this.#swiper) return;

        const slide = this.#swiper.slides?.[this.#swiper.activeIndex];
        const video = slide?.querySelector('video') || null;

        this.#pauseVideos(video);

        if (!video) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          return;
        }

        video.play()?.catch(() => {});
      }

      #initSwiper(retryCount = 0) {
        if (this.#swiper) return;

        if (typeof Swiper === 'undefined') {
          if (retryCount >= SWIPER_RETRY_LIMIT) return;

          if (document.readyState === 'complete') {
            this.#timers.push(
              window.setTimeout(
                () => this.#initSwiper(retryCount + 1),
                SWIPER_RETRY_DELAY,
              ),
            );
          } else {
            window.addEventListener(
              'load',
              () => this.#initSwiper(retryCount + 1),
              { once: true },
            );
          }

          return;
        }

        const allowTouchMove = this.dataset.disableMediaTouch !== 'true';
        const prevEl = this.querySelector('[data-product-card-prev]');
        const nextEl = this.querySelector('[data-product-card-next]');

        this.#swiper = new Swiper(this.#swiperElement, {
          slidesPerView: 1,
          loop: true,
          allowTouchMove,
          /* Desktop is arrows-only per design; drag stays touch-native. */
          simulateTouch: false,
          watchOverflow: true,
          navigation: {
            prevEl,
            nextEl,
            disabledClass: 'product-card__nav-button--disabled',
          },
          /* Swiper's a11y module rewrites the button labels on init, so feed it
             the translated strings or its English defaults ship to production. */
          a11y: {
            prevSlideMessage: this.dataset.prevLabel || undefined,
            nextSlideMessage: this.dataset.nextLabel || undefined,
          },
          /* Pause on slideChange so the outgoing clip stops the moment the
             swipe commits; play on transition end so the video only starts
             once its slide has actually settled. */
          on: {
            slideChange: () => this.#pauseVideos(),
            slideChangeTransitionEnd: () => this.#playActiveVideo(),
          },
        });

        this.#maybeNudge();
      }

      /* sessionStorage throws when cookies are blocked or storage is full.
         Treat any failure as "already nudged" so the animation can never run
         on a loop for someone whose browser will not remember it. */
      #nudgeAlreadySeen() {
        try {
          return window.sessionStorage.getItem(NUDGE_SESSION_KEY) === '1';
        } catch (error) {
          return true;
        }
      }

      #markNudgeSeen() {
        try {
          window.sessionStorage.setItem(NUDGE_SESSION_KEY, '1');
        } catch (error) {
          /* Nothing to do — the guard above already fails closed. */
        }
      }

      /* Peek at slide 2 on touch devices to advertise the carousel. Once per
         session, per the ticket: it is a hint, not a decoration. */
      #maybeNudge() {
        if (!this.#swiper) return;
        if (!this.#swiper.allowTouchMove) return;
        if (this.#nudgeAlreadySeen()) return;
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          return;
        }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          return;
        }

        const item = this.closest('.collection-page__item');

        if (!item) return;
        if (item.parentElement?.firstElementChild !== item) return;

        /* Swiper inits at a 200px margin, so the card can still be below the
           fold here. Wait for the media to be genuinely on screen before
           starting the delay — otherwise the one nudge the session gets is
           spent on an animation nobody saw. */
        if (!('IntersectionObserver' in window)) {
          this.#nudgeVisible = true;
          this.#scheduleNudge();
          return;
        }

        this.#nudgeObserver = new IntersectionObserver(
          (entries) => {
            const visible = entries.some((entry) => entry.isIntersecting);

            if (visible === this.#nudgeVisible) return;

            this.#nudgeVisible = visible;

            if (visible) this.#scheduleNudge();
          },
          { threshold: NUDGE_VISIBLE_RATIO },
        );

        this.#nudgeObserver.observe(this.#media);
      }

      #scheduleNudge() {
        this.#timers.push(
          window.setTimeout(() => {
            if (!this.#swiper || this.#swiper.destroyed) return;
            if (this.#swiper.activeIndex !== 0) return;
            /* Scrolled back off during the delay — leave it for the next time
               the card comes into view. */
            if (!this.#nudgeVisible) return;

            /* Claim the session here, not when the timer is scheduled — a card
               that scrolls out and gets torn down first never animated, so it
               should not spend the one nudge the session gets. */
            if (this.#nudgeAlreadySeen()) return;
            this.#markNudgeSeen();

            this.#nudgeObserver?.disconnect();
            this.#nudgeObserver = null;

            const peek = this.#swiper.width * NUDGE_PEEK_RATIO;

            this.#swiper.translateTo(-peek, NUDGE_SPEED, false, false);

            this.#timers.push(
              window.setTimeout(() => {
                if (!this.#swiper || this.#swiper.destroyed) return;

                this.#swiper.translateTo(0, NUDGE_SPEED, false, false);
              }, NUDGE_SPEED + NUDGE_HOLD),
            );
          }, NUDGE_DELAY),
        );
      }
    }

    customElements.define(COMPONENT_NAME, ProductCard);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-complementary"] && !Shopify.designMode) return;
  try {
    /*
   * Mobile pagination for the Perfect Hue carousel. The list is a plain
   * scroll-snap row, so the indicator is derived from scroll position rather
   * than a carousel library. Panels are filled lazily by
   * product-complementary.js, hence the MutationObserver rebuild.
   */
  (() => {
    const buildBullets = (pagination, count) => {
      if (pagination.childElementCount === count) return;

      pagination.replaceChildren();

      if (count < 2) return;

      for (let index = 0; index < count; index += 1) {
        const bullet = document.createElement('span');
        bullet.className = 'carousel-pagination__bullet';
        pagination.append(bullet);
      }
    };

    const syncActive = (list, pagination) => {
      const bullets = pagination.children;

      if (!bullets.length) return;

      const first = list.firstElementChild;
      const step = first ? first.getBoundingClientRect().width + 20 : 1;
      const index = Math.min(
        bullets.length - 1,
        Math.max(0, Math.round(list.scrollLeft / step)),
      );

      for (let i = 0; i < bullets.length; i += 1) {
        bullets[i].classList.toggle(
          'carousel-pagination__bullet--active',
          i === index,
        );
      }
    };

    const bind = (pagination) => {
      const panel = pagination.closest('[data-perfect-hue-panel]');
      const scope = panel || pagination.closest('product-complementary');
      const list = scope?.querySelector('[data-complementary-list]');

      if (!list || pagination.dataset.bound === 'true') return;

      pagination.dataset.bound = 'true';

      const refresh = () => {
        buildBullets(pagination, list.childElementCount);
        syncActive(list, pagination);
      };

      list.addEventListener('scroll', () => syncActive(list, pagination), {
        passive: true,
      });
      new MutationObserver(refresh).observe(list, { childList: true });
      refresh();
    };

    const bindAll = () => {
      for (const pagination of document.querySelectorAll(
        '[data-complementary-pagination]',
      )) {
        bind(pagination);
      }
    };

    bindAll();
    document.addEventListener('shopify:section:load', bindAll);
    document.addEventListener('colourway:change', bindAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
